import type { AppointmentStatus } from '@bb/domain/dist/types';
import axios from 'axios';

export type TourStopAddToTourModal = {
  time?: Date;
  timeEnd?: Date;
  originalTime?: Date;
  originalTimeEnd?: Date;
  status?: AppointmentStatus;
  listingContactTimeChange?: boolean;
};

const getTours = async (): Promise<
  {
    id: string;
    date: Date;
    name: string;
    stops: TourStopAddToTourModal[];
  }[]
> => {
  const { data: tourList } = await axios.get(`/tours/existing_tours`);
  // transform date string into actual date object
  return tourList
    .map(
      (tour: {
        date: string;
        stops: {
          time: string;
          timeEnd: string;
          originalTime?: string;
          originalTimeEnd?: string;
          status?: AppointmentStatus;
          listingContactTimeChange?: boolean;
        }[];
      }) => ({
        ...tour,
        date: new Date(tour.date),
        stops: tour.stops
          .map(stop => ({
            ...stop,
            time: stop.time ? new Date(stop.time) : undefined,
            timeEnd: stop.timeEnd ? new Date(stop.timeEnd) : undefined,
            originalTime: stop.originalTime
              ? new Date(stop.originalTime)
              : undefined,
            originalTimeEnd: stop.originalTimeEnd
              ? new Date(stop.originalTimeEnd)
              : undefined,
          }))
          .sort((a, b) => {
            const aValue = a.time ? +a.time : Number.MAX_VALUE;
            const bValue = b.time ? +b.time : Number.MAX_VALUE;
            return aValue - bValue;
          }),
      }),
    )
    .sort((a: any, b: any) => {
      // sort by date, startTime, then name
      let [dateCompareResult, startTimeCompareResult, nameCompareResult] = [
        0, 0, 0,
      ];
      if (+a.date - +b.date !== 0)
        dateCompareResult = +a.date - +b.date > 0 ? 1 : -1;

      const startTimeOfAValue = a.stops[0]?.time
        ? +a.stops[0]?.time
        : Number.MAX_VALUE;
      const startTimeOfBValue = b.stops[0]?.time
        ? +b.stops[0]?.time
        : Number.MAX_VALUE;

      if (startTimeOfAValue - startTimeOfBValue !== 0)
        startTimeCompareResult =
          startTimeOfAValue - startTimeOfBValue > 0 ? 1 : -1;

      if (a.name !== b.name) nameCompareResult = a.name > b.name ? 1 : -1;

      return (
        dateCompareResult * 4 + startTimeCompareResult * 2 + nameCompareResult
      );
    });
};

export default getTours;
